import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'corner-left-up', 'IconCornerLeftUp', [["path",{"d":"M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4","key":"svg-0"}]]);